// src/screens/OrderSummaryScreen.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const OrderSummaryScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cartItems = location.state?.cartItems || [];

  const total = cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4 text-center">Order Summary</h1>

      <ul className="divide-y border rounded-lg mb-4">
        {cartItems.map((item, index) => (
          <li key={index} className="p-4 flex justify-between items-center">
            <div>
              <p className="font-medium">{item.name} x {item.qty}</p>
              <p className="text-sm text-gray-500">₹{item.price} each</p>
            </div>
            <span className="font-semibold">₹{item.price * item.qty}</span>
          </li>
        ))}
      </ul>

      <div className="text-right mb-4">
        <h2 className="text-lg font-semibold">Total: ₹{total.toFixed(2)}</h2>
      </div>

      <button
        onClick={() => navigate('/invoice', { state: { cartItems, total } })}
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
      >
        Proceed to Invoice
      </button>
    </div>
  );
};

export default OrderSummaryScreen;
